// @flow
import {
  WebComponent,
} from 'fg-frontend';
import $ from 'jquery';
import 'plugins/slickSlider.js';

export default class Webslider extends WebComponent {

  didMount() {
    let lang = $('html').attr('lang');
    let messages = {
      'cs': {
        previous: 'Předchozí',
        next: 'Následující',
        stop: 'Pozastavit přehrávání',
        play: 'Spustit přehrávání',
      },
      'en': {
        previous: 'Previous',
        next: 'Next',
        stop: 'Stop',
        play: 'Play',
      }
    };

    $(this.element).slick({
      autoplay: true,
      autoplaySpeed: 2000,
      dots: false,
      arrows: true,
      vertical: true,
      verticalSwiping: true,
      infinite: true,
      slidesToShow: 3,
      slidesToScroll: 1,
      appendArrows: $('.slider-navigation'),
      prevArrow: '<button type="button" class="slick-prev" aria-label="'+messages[lang]['previous']+'"><span class="glyphicon glyphicon-arrow" aria-hidden="true"></span></button>',
      nextArrow: '<button type="button" class="slick-next" aria-label="'+messages[lang]['next']+'"><span class="glyphicon glyphicon-arrow" aria-hidden="true"></span></button>',
    });

    const $buttonPause = $('.slick-pause');
    $buttonPause.insertBefore($('.slick-prev'));
    $buttonPause.on('click', function() {
      const $pauseBtn = $(this);
      const $glyphiconPause = $('.glyphicon-pause');
      const $glyphiconPlay = $('.glyphicon-play');

      if ($pauseBtn.hasClass('paused')){
        $('#js_slickSlider').slick('slickPlay');
        $pauseBtn.removeClass('paused');
        $glyphiconPause.addClass('glyphicon-play');
        $glyphiconPause.removeClass('glyphicon-pause');
        $pauseBtn.attr('aria-label', messages[lang]['stop']);
      } else {
        $('#js_slickSlider').slick('slickPause');
        $pauseBtn.addClass('paused');
        $glyphiconPlay.addClass('glyphicon-pause');
        $glyphiconPlay.removeClass('glyphicon-play');
        $pauseBtn.attr('aria-label', messages[lang]['play']);
      }
    });
  }
}



// WEBPACK FOOTER //
// ./fe/web-default/src/js/components/Webslider.js